import React, { memo } from 'react';
import styled from '@emotion/styled';
import { SortDirection } from '../../types';
import { TableHeaderProps } from '../types';
import { SortableHeaderCell as ReactGridSortableHeaderCell } from './headerCells/HeaderCells';

export const defaultHeaderRenderer = memo(function formatter(cellProps: TableHeaderProps) {
  return (
    <SortableHeaderCell cellProps={cellProps}>
      <HeaderElement>{cellProps.column.name}</HeaderElement>
    </SortableHeaderCell>
  );
});

export const centerHeaderRenderer = memo(function formatter(cellProps: TableHeaderProps) {
  return (
    <SortableHeaderCell cellProps={cellProps}>
      <CenterHeaderElement>{cellProps.column.name}</CenterHeaderElement>
    </SortableHeaderCell>
  );
});

export const SortableHeaderCell = ({
  cellProps,
  children,
}: {
  children: React.ReactNode;
  cellProps: TableHeaderProps;
}) => {
  const { sortColumn, sortDirection } = cellProps;
  return (
    <ReactGridSortableHeaderCell
      onSort={(_, direction: SortDirection) => {
        if (cellProps.onSort) {
          cellProps.onSort(cellProps.column.key, direction);
        }
      }}
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      column={cellProps.column}
    >
      {children}
    </ReactGridSortableHeaderCell>
  );
};

const HeaderElement = styled.div`
  font-size: var(--ds-fontSizes-xs);
  font-weight: var(--ds-fontWeights-medium);
  color: var(--ds-colors-muted);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  .rdg-header-sort-cell {
    width: 100% !important;
    height: 100% !important;
  }
`;

const CenterHeaderElement = styled(HeaderElement)`
  text-align: center;
`;
